import * as angular from "angular";

export class ItinerariesRequestsService {

  /* @ngInject */
  constructor(private ItinerariesAPI, private ItinerariesPageableAPI, private $itineraries, private $itinerariesPageable) {
  }

  // ******************************
  //        Public methods
  // ******************************

  getItineraries(agentIds) { //agent or itinerary ids
    const api = this.ItinerariesAPI.actions.getItineraries;
    return this.$$call(api, {ids: agentIds}, {}, {});
  }

  getPageableItineraries(params) {
    if (!params) {
      params = {};
    }
    const api = this.ItinerariesPageableAPI.actions.getItineraries;
    return this.$$callPageable(api, params, {}, {});
  }

  // ******************************
  // Internal methods
  // ******************************

  $$call(_apiCall, _params, _data, _options, itineraryId?) {
    return this.$itineraries(itineraryId).$call(_apiCall, _params, _data, _options);
  }

  $$callPageable(_apiCall, _params, _data, _options) {
    return this.$itinerariesPageable().$call(_apiCall, _params, _data, _options);
  }

}

angular
  .module('bringoz.admin.itineraries')
  .service('itinerariesRequestsService', ItinerariesRequestsService);
